import {
	Component,
	AfterViewInit,
	Input,
	ViewChild,
	ElementRef,
	ViewEncapsulation,
	OnDestroy,
	ChangeDetectionStrategy,
	ChangeDetectorRef
} from '@angular/core';
import { IdService } from '../../shared/services/id.service';

@Component({
	selector: 'rbc-card',
	templateUrl: './card.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent implements AfterViewInit, OnDestroy {
	@Input() flush: boolean;
	@Input() height: number;
	@Input() id: string;
	@Input() link: string;
	@Input() linkLabel: string;
	@Input() scrollable: boolean;
	@Input() target: string = '_blank';

	@ViewChild('cardHeader') header: ElementRef;
	@ViewChild('cardFooter') footer: ElementRef;
	@ViewChild('body') body: ElementRef;

	headerFlag = true;
	footerFlag = true;

	constructor(private idService: IdService, private cdr: ChangeDetectorRef) {
		this.id = idService.generate();
	}

	ngAfterViewInit() {
		const headerCheck = this.header.nativeElement.children.length;
		const footerCheck = this.footer.nativeElement.children.length;
		if (!headerCheck || !footerCheck) {
			if (!headerCheck) {
				this.headerFlag = false;
			}

			if (!footerCheck) {
				this.footerFlag = false;
			}

			this.cdr.detectChanges();
		}
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	// sed to scroll the card programatically
	scrollBody(val) {
		this.body.nativeElement.scrollTop = val;
	}
}
